




















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import i18n from "@/i18n";
import { mapState } from "vuex";
import { IState } from "@/store";
import { BrandConfigKeys } from "@/data/constants";

@Component({
  components: {
    "support-pin-view": () =>
      import("@/components/app/client/clientSupportPinView.vue")
  },
  computed: {
    ...mapState({
      showSupportPin(state: IState) {
        return state.brand.config[BrandConfigKeys.SUPPORT_PIN_ENABLED];
      }
    })
  }
})
export default class ClientSupportMenu extends Vue {
  @Prop({ default: () => () => i18n.t("_.menu") })
  public title!: () => string;

  @Prop({ required: true })
  public routes!: any;

  // Data

  public readonly showSupportPin!: boolean;
}
